import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { Container } from '@mui/material';
import { UserTypeEnum } from 'enums';
import MinimalLayout from 'layouts/MinimalLayout';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function CheckoutLayout({ children }) {
  const router = useRouter();
  const { user } = useAuthUser();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    const isLabResearcherMember = user.team !== 1 && user.tp_user !== UserTypeEnum.LAB_RESEARCHER;

    if (isLabResearcherMember) {
      router.push('/my-account/overview');
      return;
    }
  }, [user, router.query]);

  return (
    <MinimalLayout showBackButton>
      <Container>{children}</Container>
    </MinimalLayout>
  );
}
